import React from "react";
import { Helmet } from "react-helmet";

export default function SeoPage({ title, description, heading, children }) {
  return (
    <div className="bg-[#0b0b12] text-white py-16 px-6">

      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>

      <div className="max-w-5xl mx-auto">

        <h1 className="text-4xl font-bold mb-6">{heading}</h1>

        <div className="text-gray-400 space-y-4 leading-relaxed">
          {children}
        </div>

      </div>

    </div>
  );
}